export const allQuestions = [
  {
    id: 1,
    type: "single",
    q: "Are your periods regular?",
    sub: "By 'regular,' we mean the gap between your periods is roughly the same number of days each month.",
    options: [
      { 
        label: "Yes", 
        note: "Nice! This helps us understand your cycle better so we can personalize things for you." 
      },
      { 
        label: "No", 
        note: "Totally okay. A lot of people have irregular cycles. This helps us support you in the right way." 
      },
      { 
        label: "I don't know", 
        note: "No worries at all. Periods can be confusing. Your answer still helps us learn how to show up for you." 
      }
    ],
  },
  {
    id: 2,
    type: "single",
    q: "How many days does your period cycles last?",
    options: [
      { label: "2-3 days" },
      { label: "3-5 days" },
      { label: "5-7 days" },
      { label: "More than 7 days" },
    ],
  },
  {
    id: 3,
    type: "single",
    q: "How do you feel about your periods",
    options: [
      { 
        label: "It’s a love-hate relationship", 
        note: "Some days it’s okay, some days it’s not. We’ve got your back." 
      },
      { 
        label: "Embarrassed", 
        note: "Totally normal. You can explore and learn quietly, no judgment." 
      },
      { 
        label: "Hate it", 
        note: "Valid. You’re not alone. We’ll help make it easier." 
      },
      { 
        label: "I want to understand it better", 
        note: "Let’s decode your body together, simply." 
      },
      { 
        label: "We’ve become friends", 
        note: "We love that energy. Let’s keep you in sync every month." 
      }
    ],
  },
  {
    id: 4,
    type: "single",
    q: "How heavy is your flow at the start of your period?",
    sub: "(First 1–3 days)",
    options: [
      { label: "Light" },
      { label: "Medium" },
      { label: "Heavy" },
      { label: "Very Heavy" },
    ],
  },
  {
    id: 5,
    type: "multi",
    q: "Do you experience any of these symptoms during your cycle?",
    sub: "Choose all that apply.",
    options: [
      { label: "Cramps", note: "Super common. If they bother you, it’s totally valid to mention them." },
      { label: "Bloating", note: "That heavy, puffy feeling? Yep, it counts. You’re not imagining it." },
      { label: "Mood swings", note: "Feeling extra emotional sometimes happens. You’re definitely not alone." },
      { label: "Headaches", note: "Annoying and exhausting, we know. It’s okay to include them." },
      { label: "Fatigue", note: "Feeling more tired than usual? Very common around your cycle." },
      { label: "Tender breasts", note: "This can happen and it’s normal — even if it feels uncomfortable." },
      { label: "Backache", note: "Back pain can be part of period symptoms too, not just cramps." },
      { label: "Leg pain / heaviness", note: "Aches or heavy legs can show up with your cycle and are worth sharing." },
      { label: "None", note: "Nothing comes to mind right now." }
    ],
  },
  {
    id: 6,
    type: "single",
    q: "Are you a pregnant?",
    options: [
      { label: "No, but I want to be" },
      { label: "No" },
      { label: "Yes, I am" },
    ],
  },
  {
    id: 7,
    type: "single",
    q: "What birth control do you use, if any",
    sub: "We’re asking because some types of birth control can impact your cycle.",
    options: [
      { label: "Nothing" },
      { label: "Pills, ring, Diaphragm" },
      { label: "Implants or injections" },
      { label: "Hormonal IUD" },
      { label: "Copper IUD" },
      { label: "Condoms" },
      { label: "Pull-out method" },
      { label: "Emergency contraception" },
      { label: "Something else" },
      { label: "Prefer not to say" },
    ],
  },
  {
    id: 8,
    type: "multi",
    q: "Do you experience any of these health conditions",
    sub: "Choose all that apply.",
    options: [
      { label: "Yeast infections" },
      { label: "Urinary tract infections" },
      { label: "Bacterial vaginosis" },
      { label: "Polycystic ovary syndrome" },
      { label: "Endometriosis" },
      { label: "Fibroids" },
      { label: "Recurrent vaginal infections or discharge" },
      { label: "Vaginal or vulvar itching/burning" },
      { label: "Vaginal dryness or pain during sex" },
      { label: "I’m not sure" },
      { label: "Prefer not to say" },
      { label: "None of the above" },
    ],
  },
  {
    id: 9,
    type: "single",
    q: "Does your cycle affect your sleep?",
    options: [
      { label: "Yes", note: "Sleep changes can happen, and you’re not alone in that." },
      { label: "No", note: "That’s great to hear. We love a good night’s sleep." },
      { label: "I’m not sure", note: "Sleep patterns can be hard to notice sometimes." }
    ],
  },
  {
    id: 10,
    type: "single",
    q: "Does your cycle impact your skin",
    options: [
      { label: "Yes", note: "That happens to many people. Skin changes around your cycle are common." },
      { label: "No", note: "Glad your skin is feeling steady." },
      { label: "I’m not sure", note: "No worries. Skin patterns can be subtle." }
    ],
  },
  {
    id: 11,
    type: "single",
    q: "Does your cycle affect your energy or activity levels",
    options: [
      { label: "Yes", note: "That’s very common. Energy levels can change throughout your cycle." },
      { label: "No", note: "It’s great when energy feels consistent." },
      { label: "I’m not sure", note: "Totally fine. It’s not always easy to tell." }
    ],
  },
  {
    id: 12,
    type: "single",
    q: "Does your cycle affect your diet",
    options: [
      { label: "Yes", note: "Appetite and cravings can change at different times." },
      { label: "No", note: "Nice. Sounds like your eating habits stay steady." },
      { label: "I’m not sure", note: "Totally okay. Many people aren’t sure." }
    ],
  },
  {
    id: 13,
    type: "single",
    q: "Does your cycle impact your digestion",
    options: [{ label: "Yes" }, { label: "No" }, { label: "I’m not sure" }],
  },
  {
    id: 14,
    type: "multi",
    q: "Does your cycle impact any aspect of your mental health?",
    sub: "Choose all that apply.",
    options: [
      { label: "Mood swings", note: "Emotions can go up and down — it happens." },
      { label: "Anxiety", note: "Feeling more anxious sometimes? You’re not alone." },
      { label: "Fatigue", note: "Extra tired for no clear reason? Yep, it happens." },
      { label: "Irritability", note: "Little things feel bigger than usual? Makes sense." },
      { label: "Low mood", note: "Feeling low or “meh” sometimes is valid." },
      { 
        label: "I have Premenstrual Dysphoric disorder (PMDD)", 
        note: "PMDD is a severe type of PMS experienced by around 5% of women and people with periods." 
      },
      { label: "None", note: "Nothing comes to mind right now." },
    ],
  },
  {
    id: 15,
    type: "input",
    q: "How tall are you?",
    placeholder: "e.g. 165 cm or 5'5\"",
  },
  {
    id: 16,
    type: "input",
    q: "How much do you weigh?",
    placeholder: "e.g. 60 kg or 130 lbs",
  },
];